import React from "react";
import {Input} from "reactstrap";
import CrifReportType from "../enums/crifReportType";

class CrifReportTypeSelect extends React.Component {

    constructor() {
        super();
    }

    iterateProperties = function() {
        let obj = CrifReportType;
        let properties = [];

        for (const prop in obj) {
            if (obj.hasOwnProperty(prop) && Number(prop)) {
                properties.push({id: prop, name:obj[prop]});
            }
        }

        return properties;
    };

    onFieldChange(event) {
        this.props.onChange(event);
    }

    render() {
        return  <Input className="mb-3" type="select" onChange={this.onFieldChange.bind(this)} name={this.props.name} data-number={true}>
                    <option value={null}>
                        Sélectionnez...
                    </option>
                    {this.iterateProperties().map((element, index) => (
                        <option key={index} value={element.id}>{element.name}</option>
                    ))}
                </Input>;
    }
}

export default CrifReportTypeSelect;